import { memo, useEffect, useState } from 'react';

import { getDateStringWithTimeZone } from '@app/utils/dateUtils';
import { Box } from '@mui/material';
import TextField from '@mui/material/TextField';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

interface CustomEpgSearchProps {
  handleChangeFilters?(filters: GenericObject): void;
}

export const CustomEpgSearch = memo(({ handleChangeFilters }: CustomEpgSearchProps) => {
  const [value, setValue] = useState<Dayjs | null>(dayjs());

  const formatDate = (date: Dayjs | null) => {
    return date && date.isValid() ? getDateStringWithTimeZone(date) : null;
  };

  useEffect(() => {
    handleChangeFilters && handleChangeFilters({ date_target: formatDate(value) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: 8 }}>
        <Box display="flex" alignItems="flex-end" sx={{ width: '30%' }}>
          <Box component="span" mr={2} sx={{ width: '100%', margin: '8px 8px 4px 8px' }}>
            <DesktopDatePicker
              label="Date"
              value={value}
              inputFormat="DD/MM/YYYY"
              onChange={(newValue) => {
                setValue(newValue);
                if (handleChangeFilters && newValue && newValue.isValid()) {
                  handleChangeFilters({ date_target: formatDate(newValue) });
                }
              }}
              renderInput={(params) => <TextField data-cy="epg-date" variant="outlined" {...params} fullWidth />}
            />
          </Box>
        </Box>
      </div>
    </LocalizationProvider>
  );
});
